module.exports = __webpack_public_path__ + "media/images/category_icons/hotels-9c41aad2908cab8b20999290f6a8f5aa.svg";